import Fetch from 'jsx/common/util/_fetch';

const remove = async (id: string) => {
  return Fetch.delete(`/api/remote-profile/${id}/`);
};

export default remove;
